import React, {Component} from 'react';
import './home-message.scss';
import {Link} from 'react-router-dom';

class HomeMessage extends Component {
    render() {
        if (this.props.returning) {
            return (
                <div className="home-message-container">
                    <p>
                        {this.props.text}
                    </p>
                    <Link to="/progress/">
                        <button type="submit">Get Back to Growing</button>
                    </Link>
                </div>
            );
        } else {
            return (
                <div className="home-message-container">
                    <p>
                        {this.props.text}
                    </p>
                    <Link to="/questions/">
                        <button type="submit">Take Assessment</button>
                    </Link>
                </div>
            );
        }

    }

}


export default HomeMessage;